import { render, staticRenderFns } from "./monthly-withdrawal-history.vue?vue&type=template&id=0f5ed01e"
import script from "./monthly-withdrawal-history.vue?vue&type=script&lang=js"
export * from "./monthly-withdrawal-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports